import script from "./xianshangzuoye.vue?vue&type=script&setup=true&lang=js"
export * from "./xianshangzuoye.vue?vue&type=script&setup=true&lang=js"

import "./xianshangzuoye.vue?vue&type=style&index=0&id=40de4dcf&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40de4dcf"]])

export default __exports__